// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__Ef4PG","headers":"otherPropertyItemNew_headers__NTkyA","semiTitle":"otherPropertyItemNew_semiTitle__crbbr"};